export default __webpack_public_path__ + "static/media/sign-up-background.7f9ed0fb.jpg";